import styled from "styled-components";

export const MainContent = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: flex-start;
    z-index: 1;
`;

